/**
 * Created by HTZ on 2019/6/27.
 */
import {Message} from 'element-ui';
const Checker = {
  notEmpty(message='不能为空'){
    return {
      required: true, message, trigger: 'blur'
    }
  },
  minLen(len){
    return {
      validator: function (rule, value, callback) {
        if (String(value).length < len) {
          return callback(new Error('长度不能小于' + (len)));
        }
        callback();
      }, trigger: 'blur'
    }
  },
  maxLen(len){
    return {
      validator: function (rule, value, callback) {
        if (String(value).length > len) {
          return callback(new Error('长度不能大于' + (len)));
        }
        callback();
      }, trigger: 'blur'
    }
  },
  eqLen(len){
    return {
      validator: function (rule, value, callback) {
        if (String(value).length != len) {
          return callback(new Error('长度必须等于' + (len)));
        }
        callback();
      }, trigger: 'blur'
    }
  },
  isEmail(){
    return {
      validator: function (rule, value, callback) {
        var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        if (!reg.test(value)) {
          return callback(new Error('邮箱格式不正确'));
        }
        callback();
      },
      trigger: 'blur'
    }
  },
  isCard18(){
    return {
      validator: function (rule, value, callback) {
        var reg = /\d{18}/;
        if (!reg.test(value)) {
          return callback(new Error('身份证号要是18位数字'));
        }
        callback();
      }, trigger: 'blur'
    }
  },
  isPhone11(){
    return {
      validator: function (rule, value, callback) {
        var reg = /\d{11}/;
        if (!reg.test(value)) {
          return callback(new Error('手机号要是11位数字'));
        }
        callback();
      }, trigger: 'blur'
    }
  },
  isInt (val, type) {
    var obj = {
      validator: function (rule, value, callback) {
        if (type == undefined) {
          if (!/^\d+$/.test(value)) {
            return callback(new Error('只能是正整数'));
          }
        } else if (!/^-?\d+$/.test(value)) {
          return callback(new Error('只能是整数'));
        }
        callback();
      }, trigger: 'blur'
    }
    return obj;
  },
  notEmptyIf(vue, path, val){
    var obj = {
      message: '不能为空',
      validator: (rule, value, callback) => {
        var bef = vue.getFieldVal(vue, path)
        if (bef == val && (value == '' || value == undefined || value == null || value == NaN)) {
          return callback(new Error());
        }
        callback();
      }, trigger: 'blur'
    };
    return obj;
  }
}
export const Reger = {
  error: function (msg) {
    Message({message: msg, type: 'error', showClose: true});
  },
  isInt (val, msg) {
    if (!/^-?\d+$/.test(val)) {
      this.error(msg || '只能是整数');
      return false;
    }
    return true;
  },
  isPosInt (val, msg) {
    if (!/^\d+$/.test(val)) {
      this.error(msg || '只能是正整数');
      return false;
    }
    return true;
  },
  isUrl:function (val) {
    return /^(https?|ftp|file):\/\/[^.]+\..+/img.test(val);
  },
  isNumber:function (val, msg) {
    if (Number.isNaN(Number(val))) {
      this.error(msg || '只能是数字');
      return false;
    }
    return true;  },
}
export default Checker;



// WEBPACK FOOTER //
// ./src/utils/CheckValue.js